export default "__VITE_ASSET__BC3eVz5H__"